module.exports = __webpack_public_path__ + "img/KONCILI_BANNER.6e654b28.png";